export default __webpack_public_path__ + "static/media/Lloyds_Bank.2e1133b8.svg";